export default __webpack_public_path__ + "static/media/mello_comingsoon.97c907a8.png";